import classNames from 'classnames';
import React, { useState } from 'react';
import OverflowMenu from '../../components/OverflowMenu';
import * as styles from './TopicUsersPanelRow.module.scss';

interface TopicUsersPanelRowProps {
  compact?: boolean;
  content: React.ReactNode;
  icon: React.ReactNode;
  menu?: React.ReactNode;
  onClick?: () => unknown;
}

const TopicUsersPanelRow = ({
  compact = false,
  content,
  icon,
  menu,
  onClick,
}: TopicUsersPanelRowProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div
      className={classNames(styles.row, {
        [styles.clickable]: onClick,
        [styles.menuOpen]: isMenuOpen,
        [styles.compact]: compact,
      })}
      onClick={onClick}
    >
      <div className={styles.icon}>{icon}</div>
      {content}
      {!!menu && (
        <div className={styles.overflowContainer}>
          <OverflowMenu
            open={isMenuOpen}
            onOpenChange={(value) => setIsMenuOpen(value)}
            buttonSize="lg"
          >
            {menu}
          </OverflowMenu>
        </div>
      )}
    </div>
  );
};

export default TopicUsersPanelRow;
